import React from "react";
import styles from "./home.module.css";
import HomeImg from "../../images/logoLight.jpeg";

function Home() {
  return (
    <div className="container" id="home">
      <div className={styles.home}>
        <div className={styles.home__img}>
          <img src={HomeImg} alt="" />
        </div>
        <div className={styles.home__text}>
          <p>
            يوفر <span> Core Tech Solutions </span>
            مجموعة واسعة من الخدمات يقدمها مجموعة من خبراء المهندسين مع دعم فني
            علي مدار اليوم بداية من أجهزة الكمبيوتر والخوادم والشبكات والخدمات
            السحابية وتشغيل وصيانة المعدات الإلكترونية تركيب كاميرات المراقبة و
            إنشاء مواقع الويب بطريقه احترافية تصميم جميع البرامج التي تساعد
            العملاء علي إنجاز الأعمال بمختلف مجالتها جميع خدمات الفاتورة
            الإلكترونية
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
